@if (visible) {
  <div class="logo" data-testid="logodiv"><img src="assets/img/twpub_logo2.png" alt="image" [width]="width" [height]="height"></div>
}
